import { useMemo } from "react";
import { useScopedWhere } from "#app/widgets/dashboards/scope/use-scoped-where";
import { useWidgetFilters } from "#app/widgets/dashboards/widget-filters";
import { useIssueGroupCounts } from "#app/hooks/issue-list/use-issue-group-counts";
import { combineWhereConditions } from "#app/lib/query-utils";

/** Counts the Projects in scope sitting in ONE stage NOW. The stage implies
 *  its workflow, so the tile carries no workflow choice of its own; the
 *  card's Filters and the dashboard's scope AND onto the stage like every
 *  other count. It is a now-state count, like the stat strip's Active: the
 *  dashboard's date window would count only the Projects CREATED in it.
 *  No stage picked means no query. */
export function useProjectsByStage(stageId: string | null | undefined, filters: unknown) {
  const { base, override } = useWidgetFilters(filters);
  const mergedBase = useMemo(
    () => (stageId ? (combineWhereConditions([base, { stageId: { eq: stageId } }]) ?? {}) : undefined),
    [base, stageId],
  );
  const { where } = useScopedWhere(mergedBase, { override, dateField: null });
  const { counts, ready, error } = useIssueGroupCounts({
    where: stageId ? where : undefined,
    groupBy: stageId ? "stageId" : undefined,
  });

  if (!stageId) return { value: 0, loading: false, error };
  return { value: counts[stageId] ?? 0, loading: !ready, error };
}
